// extracted by mini-css-extract-plugin
export var arrowBox = "footer-module--arrowBox--UuTeF";
export var arrowBoxOpen = "footer-module--arrowBoxOpen--ih9b8";
export var arrowIcon = "footer-module--arrowIcon--9uwwF";
export var collapsibleContent = "footer-module--collapsibleContent--3PoOk";
export var collapsibleContentOpen = "footer-module--collapsibleContentOpen--I4tBm";
export var collapsibleFooter = "footer-module--collapsibleFooter--iqpHp";
export var collapsibleFooterLogos = "footer-module--collapsibleFooterLogos--AOu0v";
export var collapsibleFooterOpen = "footer-module--collapsibleFooterOpen--XMfJX";
export var globalFooter = "footer-module--globalFooter--IfDZp";
export var hideOnMobile = "footer-module--hideOnMobile--4PYTp";
export var keolisLogo = "footer-module--keolisLogo--PGyju";
export var organizingAuthorityLogo = "footer-module--organizingAuthorityLogo--W4V3c";
export var organizingAuthorityLogoBox = "footer-module--organizingAuthorityLogoBox--GN-nq";
export var organizingAuthorityTitle = "footer-module--organizingAuthorityTitle--rE4l5";
export var showOnMobile = "footer-module--showOnMobile--iQWCD";
export var socialNetworkIcon = "footer-module--socialNetworkIcon--3enjO";
export var socialNetworksIcons = "footer-module--socialNetworksIcons--6BcX6";
export var svgImage = "footer-module--svgImage--xeaUp";
export var transportIcon = "footer-module--transportIcon--Hob3Y";
export var transportIcons = "footer-module--transportIcons--eyc1R";